import { useState, useEffect } from 'react';
import { getLocal, removeLocal, setLocal } from '../../utils/local';
import DefaultButton from '../Button/Button';
import { handleVerifyEmail } from '../../utils/EmailService';
import StaffService from '../../api/staff-service';
import { handleErrorResponse } from '../../utils/handleErrorResponse';

const VerifyEmailBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const checkVerificationStatus = async () => {
      const userData = getLocal('user');
      const bannerStatus = getLocal('email_verified_banner');

      if (!userData) return;

      try {
        const response = await StaffService.getLoggedInStaff();

        if (response?.isEmailVerified) {
          removeLocal(['email_verified_banner']);
          const updatedUser = { ...userData, isEmailVerified: true };
          setLocal('user', updatedUser);
          setIsVisible(false);
        } else {
          if (bannerStatus !== 'false') {
            setLocal('email_verified_banner', 'true');
            setIsVisible(true);
          }
        }
      } catch (error) {
        handleErrorResponse(error)
      }
    };

    checkVerificationStatus();
  }, []);



  const closeBannerHandler = () => {
    setIsVisible(false);
  };

  const resendVerificationEmail = () => {
    handleVerifyEmail(setLoading, closeBannerHandler);
  };

  if (!isVisible) return null;

  return (
    <div className="flex flex-col md:flex-row items-center mb-5 md:mb-10 gap-4 md:gap-3 rounded-lg border bg-red-100 border-red-600 px-4 py-4 md:px-10 md:py-6">
      <span className="text-2xl hidden md:block">📧</span>
      <div className="flex flex-col gap-3 text-left w-full md:w-auto">
        <div>
          <h5 className="font-jakarta text-sm md:text-base font-medium tracking-[-0.01rem]">
            Verify Your Email Address!
          </h5>
          <p className="text-xs text-[#7A7A7A]">
            We noticed you haven't verified your email address yet. Please check your inbox
            or spam folder to complete the verification process.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-10 w-full md:w-auto md:items-center md:ml-auto">
        <DefaultButton
          className="order-first md:order-none w-[210px]"
          onClick={resendVerificationEmail}
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Resend verification link'}
        </DefaultButton>
        <button
          onClick={closeBannerHandler}
          aria-label="Close banner"
          className="self-center"
        >
          ❌
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailBanner;

